<angular-template>
    <vrm-gps-widget
        widget-id="widgetId"
        icon-class="iconClass"
        custom-name="customName"
        installation="installation"
        range="range"
        is-mobile="isMobile"
        has-touch-enabled="hasTouchEnabled"
        size="size"
        item-state="itemState"
    />
</angular-template>

<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class GpsWidget extends Vue {
    @Prop()
    widgetId;
    @Prop({ type: String, default: '' })
    iconClass;
    @Prop({ type: String, default: '' })
    customName;
    @Prop({ type: Object, default: null })
    installation;
    @Prop({ type: Object, default: null })
    range;
    @Prop({ type: Boolean, default: false })
    isMobile;
    @Prop({ type: Boolean, default: false })
    hasTouchEnabled;
    @Prop({ type: String, default: '0x0' })
    size;
    @Prop({ type: Object, default: null })
    itemState;
}
</script>
